import { pxToRems } from '@awaze/design-system.utils.react';
import styled from 'styled-components';
import { onDesktop } from '../search-form-composition.styles';
export const StyledDestinationItem = styled.button `
  appearance: none;
  background: none;
  border: none;
  text-align: left;
  padding: ${pxToRems(12)} 0;
  button\& {
    cursor: pointer;
  }

  p {
    color: ${({ theme }) => theme.ColorThemeLink};
  }

  &:focus {
    outline: ${({ theme }) => theme.ColorThemeCtaPrimaryActive} auto 1px;
  }

  &:hover p {
    color: ${({ theme }) => theme.ColorThemeLinkActive};
  }

  & + & {
    border-top: 1px solid rgba(0, 0, 0, 0.09);
    ${onDesktop} {
      border: none;
    }
  }

  ${onDesktop} {
    border: none;
    padding: 0;
    display: block;
    margin-bottom: 4px;

    > div {
      padding: 0;
    }
  }
`;
//# sourceMappingURL=destination-item.js.map